<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Tops from './tops'

export default {
  page: {
    title: 'Firewall Top Reports',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Tops },
  data () {
    return {
      title: 'Top reports',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Monitoring',
          href: '/monitoring/firewalls'
        },
        {
          text: 'Top reports',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <Tops :base-path="'/monitoring/tops'" />
  </Layout>
</template>
